<template>
    <div class="data-table">
        <div class="table-container">
            <div class="buttons mb-4" :class="[ dataFilter ? 'border-b pb-4 border-secondary-light' : '' ]">
                <h2 class="text-3xl font-light mr-auto" v-text="pageTitle"></h2>

                <filter-bar v-if="dataFilter"
                    :placeholder="_.has(settingsFilter, 'placeholder') ? settingsFilter.placeholder : ''"
                ></filter-bar>

                <slot name="buttons"></slot>
            </div>

            <vuetable ref="datatable"
                :css="css.table"
                :api-url="apiUrl"
                :fields="fields"
                :append-params="params"
                :row-class="onRowClass"
                data-path="data"
                pagination-path="meta"
                @vuetable:row-clicked="onRowClick"
                @vuetable:pagination-data="onPaginationData"
                @vuetable:loading="onLoading"
                @vuetable:loaded="onLoaded"
            ></vuetable>

            <div class="pagination-meta">
                <vuetable-pagination-info ref="paginationInfo"
                    no-data-template="Nisu pronađeni zapisi"
                    info-template="{total} sveukupno"
                    :css="css.paginationInfo"
                ></vuetable-pagination-info>

                <vuetable-pagination ref="pagination"
                    @vuetable-pagination:change-page="onChangePage"
                    :css="css.pagination"
                ></vuetable-pagination>
            </div>
        </div>

        <slot
            name="actions"
            :onAction="onAction"
            :close-info="closeInfo"
            :row-data="selectedRow"
        >Actions</slot>
        <open-pdf></open-pdf>
    </div>
</template>

<script>
import { Vuetable, VuetablePagination, VuetablePaginationInfo } from 'vuetable-2'
import FilterBar from './FilterBar'
import OpenPdf from './OpenPdf'
import VuetableStyle from '../partials/VuetableStyle'

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        FilterBar,
        OpenPdf
    },

    props: {
        apiUrl: {
            required: true,
            type: String,
        },
        pageTitle: {
            required: true,
            type: String,
        },
        fields: {
            required: true,
            type: Array
        },
        dataFilter: {
            type: Boolean,
            default: true,
        },
        settingsFilter: {
            type: Array,
            default: null,
        },
    },

    data () {
        return {
            auth: window.auth,
            isLoading: false,
            css: VuetableStyle,
            selectedRow: null,
            selectedIndex: null,
            params: {},
        }
    },

    mounted () {
        Bus.$on('filterSet', (text) => {
            console.log(`Filter: ${text}`)

            this.params = {
                filter: text
            }

            this.selectedRow = null
            this.selectedIndex = null

            this.$nextTick( () => this.$refs.datatable.refresh() )
        })

        Bus.$on('filterReset', () => {
            console.log('Reset filter')

            this.params = {}

            this.selectedRow = null
            this.selectedIndex = null

            this.$nextTick( () => this.$refs.datatable.refresh() )
        })

        Bus.$on('onResolve', () => {
            console.log('Some action resolved')

            this.params = {}

            this.$nextTick( () => this.$refs.datatable.refresh() )
        })
    },

    methods: {
        onLoading() {
            this.isLoading = true
            console.log('loading...')
        },

        onLoaded() {
            this.isLoading = false
            console.log('loaded')
        },

        onPaginationData(data) {
            console.log('On pagination data')
            console.log(data)
            console.log(this.$refs.pagination)

            this.$refs.pagination.setPaginationData(data)
            this.$refs.paginationInfo.setPaginationData(data)

        },

        onChangePage(page) {
            this.$refs.datatable.changePage(page)
        },

        onAction(action, data = null, config = null) {
            console.log(`Action: ${action}`)
            console.log(data)
            console.log(config)

            // TODO: Check if config.route and config.message is set

            if (action == 'confirm') {
                Bus.$emit('confirmModal', {
                    method: config.method ? config.method : 'post',
                    route: config.route,
                    params: config.params ? config.params : null,
                    message: config.message
                })
            } else if (action == 'removed') {
              Bus.$emit('removedModal', {
                method: config.method ? config.method : 'post',
                route: config.route,
                params: config.params ? config.params : null,
                message: config.message
              })
            } else if (action == 'logs') {
                if (_.hasIn(data, 'routes.logs')) {
                    window.location.href = data.routes.logs
                }
            }
        },

        onRowClass(dataItem, index) {
            return dataItem.is_trashed ?
                (this.selectedIndex == index ? 'bg-selected-row' : 'disabled-row') :
                (this.selectedIndex == index ? 'is-selected' : '');
        },

        onRowClick(item) {
            if (!event.target.matches('.review-link') || !event.target.matches('.copy-button')) {
                this.selectedRow = item.data
                this.selectedIndex = item.index
                document.querySelector('.actions').style.transitionDuration = "0.25s";
                document.querySelector('.actions').style.transitionTimingFunction = "ease-out";
                document.querySelector('.actions').style.minWidth = "320px";
                document.querySelector('.table-container').classList.add('_actions')
                document.querySelector('.close-button').style.display = "block";
            }
        },

        closeInfo() {
            document.querySelector('.actions').style.transitionDuration = "0.25s";
            document.querySelector('.actions').style.transitionTimingFunction = "ease-out";
            document.querySelector('.actions').style.minWidth = "0";
            document.querySelector('.table-container').classList.remove('_actions')
            document.querySelector('.close-button').style.display = "none";
        }
    }
}
</script>
